import { create } from "zustand";

const WorkshopStore = create((set) => ({
  maintenanceViewerData: {},
  tenderViewerData: {},
  setMaintenceViewerData: (_data) => {
    set((prev) => ({ ...prev, maintenanceViewerData: _data }));
  },
  setTenderViewerData: (_data) => {
    set((prev) => ({ ...prev, tenderViewerData: _data }));
  },
}));

export default WorkshopStore;
